import {
    trackAppInsightsTelemetry,
    TRACK_METHOD,
} from "~/logging/applicationInsightsService";

/**
 * Console + AppInsights emission for a Computation/default type mismatch.
 *
 * Extracted so `useFunctionRecompute` and `useDefaults` report through one path
 * — the two hooks differ in whether they need to dedupe (see below), but the
 * wording and the telemetry shape must not drift between them.
 *
 * The UI callback is deliberately NOT handled here. Its dedupe rules differ per
 * caller: the reactive recompute pass re-reports on every keystroke and the
 * preview panel wants that repeat, while a default fires once per form
 * definition and needs none.
 *
 * @param {{
 *   oid: string, itemType?: string, expression?: string,
 *   expected: string, actual: string,
 *   source?: "computation" | "default",
 * }} mismatch
 * @param {string} message the designer-facing text from `formatTypeMismatch`
 */
export function logTypeMismatch(mismatch, message) {
    const source = mismatch.source ?? "computation";

    console.warn(`[${source} type mismatch] ${message}`, {
        expression: mismatch.expression,
        itemType: mismatch.itemType,
    });

    trackAppInsightsTelemetry(
        {
            message: `Computation type mismatch: ${message}`,
            properties: {
                oid: mismatch.oid,
                itemType: mismatch.itemType,
                expected: mismatch.expected,
                actual: mismatch.actual,
                expression: mismatch.expression?.slice(0, 200),
                source,
            },
            // Warning, not error: the form still renders and the item is left
            // empty, so this is a design defect to triage rather than a site
            // outage.
            severityLevel: 2,
        },
        TRACK_METHOD.TRACE
    );
}
